var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_vm._v("欢迎使用学习邦，目前部分功能正在完善，请在浏览器使用。")])
}
var staticRenderFns = []

export { render, staticRenderFns }